<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white">
                Brands that trust us
            </h1>
        </div>
        <div class="grid-container pad-bottom">
            <div class="grid-x grid-padding-x pad-top--xl">
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/barclays.png" alt="" />
                    </div>
                </div>
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/bbc.png" alt="" />
                    </div>
                </div>
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/bentley.png" alt="" />
                    </div>
                </div>
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/british-airways.png" alt="" />
                    </div>
                </div>
            </div>
            <div class="grid-x grid-padding-x pad-top--xl">
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/british-gas.png" alt="" />
                    </div>
                </div>
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/dell.png" alt="" />
                    </div>
                </div>
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/google.png" alt="" />
                    </div>
                </div>
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/heineken.png" alt="" />
                    </div>
                </div>
            </div>
            <div class="grid-x grid-padding-x pad-top--xl">
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/hp.png" alt="" />
                    </div>
                </div>
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/microsoft.png" alt="" />
                    </div>
                </div>
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/nandos.png" alt="" />
                    </div>
                </div>
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/philips.png" alt="" />
                    </div>
                </div>
            </div>
            <div class="grid-x grid-padding-x pad-top--xl">
                <div class="cell small-3">
                    <div class="pad--large">
                        <img src="../../../static/images/brands-that-trust-us/santander.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'BrandsThatTrustUs',
    metaInfo() {
        return {
            title: 'Brands that trust us',
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: 'Check out trusted brands partnered with us for personalized clothing. Take your style to the next level with our designs. Order now!' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/brands-that-trust-us' },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/BrandsThatTrustUs.vue